import clsx from 'clsx'

import SuccessImage from 'shared/images/success-tours.webp'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

type Props = {
  title: string
  description: string
  buttonText: string
  onClick: () => void
}

export const ToursSuccess = ({
  title,
  description,
  buttonText,
  onClick,
}: Props) => {
  return (
    <div className={clsx('container', 'safe-area-top-padding', s.container)}>
      <div className={s.content}>
        <img
          src={SuccessImage}
          className={s.successImage}
          alt=""
        />

        <div className={s.text}>
          <p className={clsx(s.title, 'bold-24')}>{title}</p>
          <p className={clsx(s.description, 'medium-16')}>{description}</p>
        </div>

        <div className={s.btnContainer}>
          <Button
            variant="grey"
            onClick={onClick}
          >
            <span className={clsx(s.buttonText, 'bold-16')}>{buttonText}</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
